const baseGatewayVisual = {
    statusBorderColor: 0xffffff,
    useWisps: true,
    flightOrbType: 'HTTP_ORB',
    lineColor: 0x9fe1ff,
    lineOpacity: 0.98,
    lineWidth: 6,
};
export const connectionTypeDefinitions = [
    {
        name: 'gateway',
        label: 'Gateway',
        streamUrl: 'wss://api.orbscape.io/trafficstream',
        canSend: false,
        visuals: Object.assign({}, baseGatewayVisual),
        eventHooks: {
            onConnected: ['logConnected'],
            onDisconnected: ['logDisconnected'],
            onPayload: ['spawnWisps', 'spawnFlight'],
        },
    },
    {
        name: 'event',
        label: 'Event',
        streamUrl: 'wss://api.orbscape.io/eventstream',
        canSend: false,
        visuals: Object.assign(Object.assign({}, baseGatewayVisual), { flightOrbType: 'EVENT_ORB', lineColor: 0xc084fc, lineOpacity: 1, lineWidth: 24, useWisps: false }),
        eventHooks: {
            onConnected: ['logConnected'],
            onDisconnected: ['logDisconnected'],
            onPayload: ['spawnEventPulse'],
        },
    },
    {
        name: 'world',
        label: 'World',
        streamUrl: 'wss://api.orbscape.io/worldstate',
        canSend: true,
        visuals: Object.assign(Object.assign({}, baseGatewayVisual), { lineColor: 0x81d4fa }),
        eventHooks: { onConnected: [], onDisconnected: [], onPayload: ['worldStateSync'] },
    },
    {
        name: 'serviceMesh',
        label: 'ServiceMesh',
        streamUrl: 'wss://api.orbscape.io/servicemesh',
        canSend: false,
        visuals: Object.assign({}, baseGatewayVisual),
        eventHooks: { onConnected: [], onDisconnected: [], onPayload: ['serviceMeshTransit'] },
    },
    {
        name: 'agent',
        label: 'Agent',
        streamUrl: 'wss://api.orbscape.io/agent',
        canSend: true,
        visuals: Object.assign(Object.assign({}, baseGatewayVisual), { lineColor: 0xa5d6a7 }),
        eventHooks: { onConnected: [], onDisconnected: [], onPayload: ['agentAction'] },
    },
    {
        name: 'database',
        label: 'Database',
        streamUrl: 'wss://api.orbscape.io/database',
        canSend: true,
        visuals: Object.assign(Object.assign({}, baseGatewayVisual), { lineColor: 0x90caf9 }),
        eventHooks: { onConnected: [], onDisconnected: [], onPayload: ['dbOperation'] },
    },
    {
        name: 'codeExecution',
        label: 'CodeExecution',
        streamUrl: 'wss://api.orbscape.io/codeexecution',
        canSend: true,
        visuals: Object.assign(Object.assign({}, baseGatewayVisual), { lineColor: 0xffcc80 }),
        eventHooks: { onConnected: [], onDisconnected: [], onPayload: ['executionEvent'] },
    },
    {
        name: 'multiplayer',
        label: 'Multiplayer',
        streamUrl: 'wss://api.orbscape.io/multiplayer',
        canSend: true,
        visuals: Object.assign(Object.assign({}, baseGatewayVisual), { lineColor: 0x80cbc4 }),
        eventHooks: { onConnected: [], onDisconnected: [], onPayload: ['playerEvent'] },
    },
];
const byName = new Map(connectionTypeDefinitions.map((item) => [item.name, item]));
export function getConnectionTypeDefinition(name) {
    const match = byName.get(name);
    if (!match) {
        throw new Error(`Unknown connection type: ${name}`);
    }
    return match;
}
